// Generated by ReScript, PLEASE EDIT WITH CARE


let enFallback = 'en';

let jaFallback = 'ja';

let thFallback = 'th';

let zhTWFallback = 'zh-TW';

let zhCNFallback = 'zh-CN';

export {
  enFallback,
  jaFallback,
  thFallback,
  zhTWFallback,
  zhCNFallback,
}
/* No side effect */
